import React from "react"
import styles from "./dialog.module.css"

export const Dialog = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null

  return (
    <div className={styles.dialogOverlay} onClick={onClose}>
      <div className={styles.dialogContent} onClick={(e) => e.stopPropagation()}>
        {children}
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
      </div>
    </div>
  )
}

export const DialogContent = ({ children }) => {
  return <div className={styles.dialogBody}>{children}</div>
}

export const DialogHeader = ({ children }) => {
  return <div className={styles.dialogHeader}>{children}</div>
}

export const DialogFooter = ({ children }) => {
  return <div className={styles.dialogFooter}>{children}</div>
}

export const DialogTitle = ({ children }) => {
  return <h2 className={styles.dialogTitle}>{children}</h2>
}

export const DialogDescription = ({ children }) => {
  return <p className={styles.dialogDescription}>{children}</p>
}

